import Enum from './Enum.js';

export default class KpiMeasure extends Enum {
  static MAXIMIZE = new KpiMeasure('MAXIMIZE', '最大化');
  static MINIMIZE = new KpiMeasure('MINIMIZE', '最小化');
}
